import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import PropertySearches from "../pages/PropertySearches";

// Modal wrapper around the PropertySearches page. Mounted from /contacts so
// clicking the per-row "Searches" button opens the same list filtered to the
// current contact (by email or mobile) without leaving the contacts page.
// Clicking a property card opens the property search detail in a new tab.
export default function ContactSearchesModal({ searchQuery, contactLabel, onClose }) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 768,
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Lock background scroll while the modal is open.
  useEffect(() => {
    if (!searchQuery) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [searchQuery]);

  // Close on Escape, mirroring the other modals in this app.
  useEffect(() => {
    if (!searchQuery) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [searchQuery, onClose]);

  if (!searchQuery) return null;

  const handleCardOpen = (url) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 10000,
        // Offset the overlay by the desktop sidebar width (260px, see
        // components/MainNav.js) so the modal centres within the content
        // pane to the right of the nav, not the whole viewport. On mobile
        // the sidebar is a slide-out drawer so we cover the full width.
        left: isMobile ? 0 : 260,
        background: "rgba(0,0,0,0.4)", backdropFilter: "blur(2px)",
        display: "flex",
        alignItems: isMobile ? "stretch" : "center",
        justifyContent: isMobile ? "stretch" : "center",
        padding: isMobile ? 0 : 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: isMobile ? 0 : 16,
          width: "100%",
          maxWidth: isMobile ? "none" : 960,
          height: isMobile ? "100%" : "auto",
          maxHeight: isMobile ? "100%" : "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          padding: "14px 20px", borderBottom: "1px solid #e5e7eb", flexShrink: 0,
        }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 17, fontWeight: 700, color: "#1f2937" }}>
              Property Searches
            </div>
            {contactLabel && (
              <div style={{
                fontSize: 12, color: "#6b7280", marginTop: 2,
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
              }}>
                {contactLabel}
              </div>
            )}
          </div>
          <button
            onClick={onClose}
            title="Close"
            style={{
              background: "none", border: "none", cursor: "pointer", padding: 6,
              color: "#9ca3af", fontSize: 16,
            }}
          >
            <FaTimes />
          </button>
        </div>

        <div style={{
          flex: 1, minHeight: 0, overflowY: "auto",
          padding: isMobile ? "12px 16px 24px" : "16px 24px 24px",
          background: "#f6f8fa",
        }}>
          <PropertySearches
            embedded
            embeddedSearch={searchQuery}
            onCardOpen={handleCardOpen}
          />
        </div>
      </div>
    </div>
  );
}
